export default {
  itens: [],
  selects: {
    tipo: [
      { value: 1, text: "Campo Descritivo (Sim, Não)" },
      { value: 2, text: "Campo Quantitativo (Valores)" }
    ],
    grupo: [
      { value: 1, text: "Autonomias" },
      { value: 2, text: "Parâmentros" },
      { value: 3, text: "Visualizações" }
    ],
    regra: [
      { value: 1, text: "Ativa(A regra será aplicada no momento da ação)" },
      {
        value: 2,
        text: "Reativa(A regra será enviado para workflow de aprovação)"
      }
    ],
    tabela: [],
    coluna: []
  }
};
